module.exports = __webpack_public_path__ + "static/all_travel_no_worries_text-3213023af601cffbb6795bc9917776ad.svg";